module.exports = __webpack_public_path__ + "img/coverpage_group.b8fdd900.png";